module.exports = __webpack_public_path__ + "5881c1cd35b514261c891267beb79cb4.jpg";